import { v4 as uuidv4 } from "uuid";
export class AssetHistoryModel {
    constructor() {
        this.id = uuidv4();
        this.assetId = "";
        this.assetStatusTypeId = "";
        this.timeStampFormatTime = "";
        this.timeStampAsString = "";
        this.assignmentEndDate = "";
        this.assignmentEndDateFormatTime = "";
        this.assignmentEndDateAsString = "";
        this.assetStatus = "";
        this.employeeName = "";
    }
}
export default class AssetHistory extends AssetHistoryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
